import React from 'react';

interface DisciplinaryActionCardProps {
  index: number;
  name: string;
  date: string;
  position: string;
  department: string;
  supervisor: string;
  dateOfHire?: string;
  policyViolation: string;
  reasonForDisciplinaryAction: string;
  actionTaken: string;
  expectedImprovement: string;
  privateNotes?: string;
  createdAt?: string;
}

const DisciplinaryActionCard = ({
  index,
  name,
  date,
  position,
  department,
  supervisor,
  dateOfHire,
  policyViolation,
  reasonForDisciplinaryAction,
  actionTaken,
  expectedImprovement,
  privateNotes,
  createdAt,
}: DisciplinaryActionCardProps) => {
  return (
    <div className="mb-4 p-3 border rounded" style={{ backgroundColor: '#f8f9fa' }}>
      <h6 className="text-primary mb-3">
        <i className="fas fa-user mr-2" />
        {index + 1}. {name}
      </h6>

      <div className="row">
        <div className="col-md-6">
          <p>
            <strong>Date:</strong> {date}
          </p>
          <p>
            <strong>Position:</strong> {position}
          </p>
          <p>
            <strong>Department:</strong> {department}
          </p>
          <p>
            <strong>Supervisor:</strong> {supervisor}
          </p>
          {dateOfHire && (
            <p>
              <strong>Date of Hire:</strong> {dateOfHire}
            </p>
          )}
        </div>
        <div className="col-md-6">
          <p>
            <strong>Policy Violation:</strong> {policyViolation}
          </p>
          {createdAt && (
            <p>
              <strong>Created At:</strong> {createdAt}
            </p>
          )}
        </div>
      </div>

      <div className="mt-3">
        <p>
          <strong>Reason for Disciplinary Action:</strong>
        </p>
        <p className="text-muted" style={{ whiteSpace: 'pre-wrap' }}>
          {reasonForDisciplinaryAction}
        </p>
      </div>

      <div className="mt-3">
        <p>
          <strong>Action Taken:</strong>
        </p>
        <p className="text-muted" style={{ whiteSpace: 'pre-wrap' }}>
          {actionTaken}
        </p>
      </div>

      <div className="mt-3">
        <p>
          <strong>Expected Improvement:</strong>
        </p>
        <p className="text-muted" style={{ whiteSpace: 'pre-wrap' }}>
          {expectedImprovement}
        </p>
      </div>

      {privateNotes && (
        <div className="mt-3">
          <p>
            <strong>Private Notes:</strong>
          </p>
          <p className="text-muted" style={{ whiteSpace: 'pre-wrap' }}>
            {privateNotes}
          </p>
        </div>
      )}
    </div>
  );
};

export default DisciplinaryActionCard;
